import React from "react";
import { Button, MenuButton } from "@chakra-ui/react";
import { getReportButtonProps } from "../Styles/reportToolbarStyles";

export function ReportMenuButton({ children, variant = "secondary", ...props }) {
  return (
    <MenuButton as={Button} {...getReportButtonProps(variant)} {...props}>
      {children}
    </MenuButton>
  );
}
